import { render, staticRenderFns } from "./tourism-terms.vue?vue&type=template&id=bd55b7a6&scoped=true"
import script from "./tourism-terms.vue?vue&type=script&lang=js"
export * from "./tourism-terms.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd55b7a6",
  null
  
)

export default component.exports